import { useContext, useMemo } from 'react';
import { DefinitionEntity } from '../../../../domain/entry.js';
import { EngineContext } from '../components/EngineProvider.js';
/**
 * Retrieves the current Tipsen engine definition.
 *
 * @returns The current Tipsen engine definition
 * @throws {Error} If the hook is used outside of the EngineProvider
 */
export function useEngine() {
    const engineContext = useContext(EngineContext);
    if (!engineContext) {
        throw new Error(`useEngine must be used within EngineProvider`);
    }
    return useMemo(() => {
        return new DefinitionEntity(engineContext);
    }, [engineContext]);
}
//# sourceMappingURL=useEngine.js.map